import React from 'react';
import { styled } from '@mui/material';

interface Props {
  value: number; // 0 to 100
  height?: number;
  background?: string;
}

const ProgressBar: React.FC<Props> = ({ value, height = 8, background = '#ffffff' }) => {
  return (
    <Wrapper barHeight={height}>
      <Inner sx={{ clipPath: `rect(auto ${value}% auto auto)`, background }} barHeight={height} />
    </Wrapper>
  );
};

export default ProgressBar;

const Wrapper = styled('div')<{ barHeight: number }>`
  overflow: hidden;
  border-radius: calc(${({ barHeight }) => barHeight}px / 2);
  background-color: ${({ theme }) => (theme.palette.mode === 'dark' ? '#000000' : theme.palette.grey[300])};
`;

const Inner = styled('div')<{ barHeight: number }>`
  height: ${({ barHeight }) => `${barHeight}px`};
`;
